import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { I18nextProvider } from 'react-i18next';
import { HelmetProvider } from 'react-helmet-async';
import Header from './components/Header';
import Home from './pages/Home';
import Setup from './pages/Setup';
import {CURRENT_GOOGLE_SHEETS, CURRENT_MS_EXCEL, LEGACY_GOOGLE_SHEETS} from './pages/Setup';
import Privacy from './pages/Privacy';
import i18n from './i18n';
import './App.css';

//Analytics Tracker for Google Analytics
import AnalyticsTracker from "./components/AnalyticsTracker";

function App() {  
  
  return (
    <I18nextProvider i18n={i18n}>
      <HelmetProvider>
        <Router>
          <div className="app">
            <AnalyticsTracker />
            <Header />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/setup-v2" element={<Setup type={CURRENT_GOOGLE_SHEETS}/>} />
                <Route path="/setup-v2-msexcel" element={<Setup type={CURRENT_MS_EXCEL}/>} />
                <Route path="/setup-legacy" element={<Setup type={LEGACY_GOOGLE_SHEETS}/>} />
                <Route path="/privacy" element={<Privacy />} />

                {/* Redirects */}
                
                <Route path="/setup-guide-v2" element={<Navigate to="/setup-v2" replace />} />
                <Route path="/setup-guide" element={<Navigate to="/setup-legacy" replace />} />
                <Route path="/privacy-policy" element={<Navigate to="/privacy" replace />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
          </div>
        </Router>
      </HelmetProvider>
    </I18nextProvider>
  );
}

export default App;